import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

export default function Layout() {
    const { admin, logout } = useAuthStore();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = {
        super_admin: [
            { to: '/', label: '📊 Dashboard' },
            { to: '/provinces', label: '🗺️ Provincias' },
            { to: '/admins/create', label: '👤 Crear Admin' }
        ],
        province_admin: [
            { to: '/', label: '📊 Dashboard' },
            { to: `/provinces/${admin?.provinceId}/municipalities`, label: '🏛️ Municipios' },
            { to: '/admins/create', label: '👤 Crear Admin' }
        ],
        municipal_admin: [
            { to: '/', label: '📊 Dashboard' },
            { to: `/municipalities/${admin?.municipalityId}/config`, label: '🤖 Config Bot' }
        ],
        staff: [
            { to: '/', label: '📊 Dashboard' }
        ]
    };

    const items = admin ? navItems[admin.role] : [];

    return (
        <div className="app-layout">
            <aside className="sidebar">
                <div className="sidebar-header">
                    <h1>🏛️ MuniPlatform</h1>
                    <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                        {admin?.role.replace('_', ' ').toUpperCase()}
                    </p>
                </div>
                <nav className="sidebar-nav">
                    {items.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                            end
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <button className="btn" onClick={handleLogout} style={{ marginTop: 'auto' }}>
                    Cerrar Sesión
                </button>
            </aside>
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}
